export interface EliteLevel {
  name: string;
  label: string;
  color: string;
  valueToAchieve: number;
}

export const ELITE_BADGE_MINIMUM_GAINS = 100000;
export const ELITE_MAXIMUM_GAINS = 100000000;

export const ELITE_LEVELS: EliteLevel[] = [
  { name: 'White Belt', label: 'R$ 0,00', color: '', valueToAchieve: 0 },
  { name: 'Red Belt', label: 'R$ 100.000', color: '--red', valueToAchieve: 100000 },
  { name: 'Orange Belt', label: 'R$ 250.000', color: '--orange', valueToAchieve: 250000 },
  { name: 'Green Belt', label: 'R$ 500.000', color: '--green', valueToAchieve: 500000 },
  { name: 'Black Belt', label: 'R$ 1.000.000', color: '--black', valueToAchieve: 1000000 },
  { name: '2º DAN', label: 'R$ 2.000.000', color: '', valueToAchieve: 2000000 },
  { name: '3º DAN', label: 'R$ 3.000.000', color: '', valueToAchieve: 3000000 },
  { name: '4º DAN', label: 'R$ 4.000.000', color: '', valueToAchieve: 4000000 },
  { name: '5º DAN', label: 'R$ 5.000.000', color: '', valueToAchieve: 5000000 },
  { name: '6º DAN', label: 'R$ 6.000.000', color: '', valueToAchieve: 6000000 },
  { name: '7º DAN', label: 'R$ 7.000.000', color: '', valueToAchieve: 7000000 },
  { name: '8º DAN', label: 'R$ 8.000.000', color: '', valueToAchieve: 8000000 },
  { name: '9º DAN', label: 'R$ 9.000.000', color: '', valueToAchieve: 9000000 },
  { name: 'Golden', label: 'R$ 10.000.000', color: '--golden', valueToAchieve: 10000000 },
  { name: '2º DAN', label: 'R$ 20.000.000', color: '', valueToAchieve: 20000000 },
  { name: '3º DAN', label: 'R$ 30.000.000', color: '', valueToAchieve: 30000000 },
  { name: '4º DAN', label: 'R$ 40.000.000', color: '', valueToAchieve: 40000000 },
  { name: '5º DAN', label: 'R$ 50.000.000', color: '', valueToAchieve: 50000000 },
  { name: '6º DAN', label: 'R$ 60.000.000', color: '', valueToAchieve: 60000000 },
  { name: '7º DAN', label: 'R$ 70.000.000', color: '', valueToAchieve: 70000000 },
  { name: '8º DAN', label: 'R$ 80.000.000', color: '', valueToAchieve: 80000000 },
  { name: '9º DAN', label: 'R$ 90.000.000', color: '', valueToAchieve: 90000000 },
  { name: 'Sensei', label: 'R$ 100.000.000', color: '', valueToAchieve: ELITE_MAXIMUM_GAINS }
];
